import { render, staticRenderFns } from "./project-level-selector.vue?vue&type=template&id=b3006210&"
import script from "./project-level-selector.vue?vue&type=script&lang=js&"
export * from "./project-level-selector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports